export default __webpack_public_path__ + "assets/1aa1563a309bd96208546a5574e22985.svg";